export default __webpack_public_path__ + "assets/994dd20c4133e434b19e70611581110d.png";